__turbopack_context__.v({
  "authorRow": "ReviewCard-module-scss-module__KAfnZG__authorRow",
  "editButton": "ReviewCard-module-scss-module__KAfnZG__editButton",
  "headerActions": "ReviewCard-module-scss-module__KAfnZG__headerActions",
  "mediaOpenButton": "ReviewCard-module-scss-module__KAfnZG__mediaOpenButton",
  "partnerDot": "ReviewCard-module-scss-module__KAfnZG__partnerDot",
  "partnerLink": "ReviewCard-module-scss-module__KAfnZG__partnerLink",
  "partnerText": "ReviewCard-module-scss-module__KAfnZG__partnerText",
  "productLink": "ReviewCard-module-scss-module__KAfnZG__productLink",
  "rating": "ReviewCard-module-scss-module__KAfnZG__rating",
  "reviewActionsRow": "ReviewCard-module-scss-module__KAfnZG__reviewActionsRow",
  "reviewCard": "ReviewCard-module-scss-module__KAfnZG__reviewCard",
  "reviewFooter": "ReviewCard-module-scss-module__KAfnZG__reviewFooter",
  "reviewHeader": "ReviewCard-module-scss-module__KAfnZG__reviewHeader",
  "reviewHighlighted": "ReviewCard-module-scss-module__KAfnZG__reviewHighlighted",
  "reviewMediaButton": "ReviewCard-module-scss-module__KAfnZG__reviewMediaButton",
  "reviewMediaButtonActive": "ReviewCard-module-scss-module__KAfnZG__reviewMediaButtonActive",
  "reviewMediaButtonStatic": "ReviewCard-module-scss-module__KAfnZG__reviewMediaButtonStatic",
  "reviewMediaPreview": "ReviewCard-module-scss-module__KAfnZG__reviewMediaPreview",
  "reviewPending": "ReviewCard-module-scss-module__KAfnZG__reviewPending",
  "reviewPhotos": "ReviewCard-module-scss-module__KAfnZG__reviewPhotos",
  "reviewText": "ReviewCard-module-scss-module__KAfnZG__reviewText",
  "reviewTextCollapsed": "ReviewCard-module-scss-module__KAfnZG__reviewTextCollapsed",
  "shopLogo": "ReviewCard-module-scss-module__KAfnZG__shopLogo",
  "showFullArrow": "ReviewCard-module-scss-module__KAfnZG__showFullArrow",
  "showFullArrowExpanded": "ReviewCard-module-scss-module__KAfnZG__showFullArrowExpanded",
  "showFullButton": "ReviewCard-module-scss-module__KAfnZG__showFullButton",
  "stars": "ReviewCard-module-scss-module__KAfnZG__stars",
  "verifiedPurchase": "ReviewCard-module-scss-module__KAfnZG__verifiedPurchase",
  "voteActive": "ReviewCard-module-scss-module__KAfnZG__voteActive",
  "voteIconDislike": "ReviewCard-module-scss-module__KAfnZG__voteIconDislike",
  "voteIconLike": "ReviewCard-module-scss-module__KAfnZG__voteIconLike",
  "votes": "ReviewCard-module-scss-module__KAfnZG__votes",
});
